import { fetchdata } from 'apis/FetchData';
import { apiConfig } from 'config';

export const getSoftwareVersions = (deviceType) => {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  let url = apiConfig.swManagerAvailability(deviceType);

  return fetchdata(url, { headers: headers, method: 'GET' })
    .then((result) => {
      //throw("44")
      // console.log("Get SW Version Response:", result);
      return result;
    })
    .catch((e) => {
      /* software versions failed to load. For now, we'll just return null which should 
               result in an empty list of sw versions. */
      throw e;
      //handleGenericError(e);
    });
};
